import { postForm } from '@/shared/api/client';
import { submitForm } from '@/shared/api/submit';
import type { SelectOption } from '@/shared/ui/selectTypes';

export const CRYPTO_STATUS = { NEW: 1, VERIFIED: 2, REJECTED: 3 } as const;

export interface CryptoItem extends Record<string, unknown> {
  id: number;
  first_name?: string;
  second_name?: string;
  last_name?: string;
  phone?: string;
  email?: string;
  wallet_number?: string;
  birthday?: number;
  citizenship?: string;
  place_of_birth?: string;
  passport_series?: string;
  passport_number?: string;
  passport_date_of_issue?: number;
  passport_organization_issued?: string;
  comments?: string;
  image?: { src?: string } | null;
  status?: { value: number; description?: string };
}

export async function fetchCryptoItem(requestId: number) {
  const res = await postForm<{ item?: CryptoItem }>('/crypto/default/view/', { request_id: requestId });
  return res.item;
}

export async function fetchRejectReasons(): Promise<SelectOption[]> {
  const res = await postForm<{ filters?: { reject_reason?: { value: number | string; description: string }[] } }>(
    '/crypto/default/get-module-filters/',
    {},
  );
  return (res.filters?.reject_reason ?? []).map((reason) => ({
    value: String(reason.value),
    label: reason.description,
  }));
}

export const changeCryptoStatus = (requestId: number, statusId: number, commentId?: string) =>
  submitForm('/crypto/default/change-status/', {
    request_id: requestId,
    status_id: statusId,
    comment_id: commentId,
  });
